import script from "./ServiciosView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiciosView.vue?vue&type=script&setup=true&lang=js"

import "./ServiciosView.vue?vue&type=style&index=0&id=ddfaf81a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddfaf81a"]])

export default __exports__